// App messages (the pop-up card at the bottom-right). The <Toaster/> mounted in App renders them.
//
//   toast(title, type, { detail, tech })
//     title  — what happened, a few words ("Audit plan copied")
//     type   — 'success' (green, done) · 'warning' (amber, you need to do something)
//              'error' (red, something failed) · 'info' (blue, just information)
//     detail — optional one line: the next step ("Paste it into the client's email")
//     tech   — optional technical reason, shown small and grey (for a support screenshot), never as the message
//
//   failed(title, err) — a save / upload / send that did not go through.
export const TRY_AGAIN = 'Try again. If it keeps happening, send a screenshot to the admin.'

export function toast(title, type = 'info', { detail, tech } = {}) {
  window.dispatchEvent(new CustomEvent('app-toast', {
    detail: {
      id: Date.now() + Math.random(), type,
      title: String(title ?? ''),
      detail: detail == null || detail === '' ? '' : String(detail),
      tech: tech == null || tech === '' ? '' : String(tech),
    },
  }))
}

export function failed(title, err, detail = TRY_AGAIN) {
  const tech = err == null ? '' : typeof err === 'string' ? err : (err.message || String(err))
  toast(title, 'error', { detail, tech })
}

// Safety net: a plain window.alert() anywhere (none are left in AuditPM's own code) still shows as a card.
export function installAlertToast() {
  if (typeof window === 'undefined' || window.__alertToastInstalled) return
  window.__alertToastInstalled = true
  window.alert = (msg) => toast(String(msg), 'info')
}
